import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { NonRetriableError } from 'query/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Client-level because retry resolves from the last observer to mount,
      // so per-hook overrides are silently lost. Matches the default 3 retries
      // except for NonRetriable failures, which can't succeed on retry.
      retry: (failureCount, error) =>
        !(error instanceof NonRetriableError) && failureCount < 3,
    },
  },
});

type QueryProviderProps = {
  children: React.ReactNode;
};
export const QueryProvider = ({ children }: QueryProviderProps) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
